import React from "react";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";

export const DataBox = () => {

    const action = <></>;

    return (
        <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
            <DataTable />
        </YhBox>
    )
}